<template>
  <section>
    <ProjectsHeader />
    <ProjectsIntro />
    <ProjectsIndex />
    <ProjectsDone />
    <ProjectsMore />
    <NavigationCta />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Projects',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['project-index'] || {}
    }
  },
  mounted() {
    console.log('project-index', this.$wp.pages['project-index'])
    console.log('wp-projects', this.$wp.projects)
  }
}
</script>
